import(/* webpackMode: "eager" */ "/app/src/app/contact/thailand/page.tsx");
